<mat-label *ngIf="title">{{ title }}</mat-label>
<mat-form-field appearance="outline" class="d-block" (click)="open()">
  <!--  [name]="uuid"-->
  <button matPrefix mat-icon-button type="button" class="date-field__button w-auto h-auto p-0" [disabled]="isDisabled">
    <app-icon name="calendar" size="sm" class="text-300"></app-icon>
  </button>
   <input
    class="inline"
    type="text"
    matInput
    [readonly]="!enableEditing"
    [placeholder]="placeHolder | translate"
    [value]="value | date: (selectMonthAndYear ? 'MMM yyyy' : enableTime ? 'd MMM, h:mm a' : 'd MMM yyyy')"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    [disabled]="isDisabled"
  />
  <mat-error *ngIf="form.invalid && form.touched && form.get('date').hasError('required')">{{ "ErrorMessages.Required" | translate }}</mat-error>
</mat-form-field>

<ng-template
  cdkConnectedOverlay
  #connectedPopup="cdkConnectedOverlay"
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayDisableClose]="true"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayPositions]="calendarPositions"
  [cdkConnectedOverlayPush]="true"
  [cdkConnectedOverlayViewportMargin]="8"
  (overlayKeydown)="onKeydown($event)"
>
  <div class="madar--v2" #calendar>
    <mat-card class="date-field__card" [formGroup]="form">
      <mat-calendar
        class="date-field__calendar"
        [minDate]="minDate"
        [maxDate]="maxDate"
        [selected]="form.get('date').value"
        (selectedChange)="form.get('date').setValue($event); !enableTime ? updateValue() : previewValue()"
        (monthSelected)="selectMonthAndYear ? setMonthAndYear($event, connectedPopup) : null"
        (yearSelected)="yearSelected($event)"
        [startView]="startView"
      ></mat-calendar>

      <div class="px-3" *ngIf="enableTime">
        <app-time-field class="date-field__time-field" formControlName="time"></app-time-field>
      </div>

      <mat-card-actions *ngIf="enableTime">
        <button mat-button (click)="isOpen = false" class="ml-auto">{{ "Buttons.Cancel" | translate }}</button>
        <button mat-button color="primary" (click)="updateValue()">{{ "Buttons.Save" | translate }}</button>
      </mat-card-actions>
    </mat-card>
  </div>
</ng-template>
